import type { AppLocale } from './locales'
import { buffSpeechCopy } from './buff-speech'
import { chineseVoiceKind, voiceId } from '@/buffs/system-voices'

const names: Record<string, [string, string]> = {
  xiaoxiao: ['晓晓', '曉曉'], yunxi: ['云希', '雲希'], huihui: ['慧慧', '慧慧'],
  yaoyao: ['瑶瑶', '瑤瑤'], kangkang: ['康康', '康康'], hanhan: ['涵涵', '涵涵'],
}
const languages = {
  'zh-CN': { mandarin: '普通话', taiwan: '国语（台湾）', hongKong: '粤语（香港）', macau: '粤语（澳门）', cantonese: '粤语', chinese: '中文' },
  'zh-TW': { mandarin: '普通話', taiwan: '國語（臺灣）', hongKong: '粵語（香港）', macau: '粵語（澳門）', cantonese: '粵語', chinese: '中文' },
}

function chineseVoiceName(voice: SpeechSynthesisVoice, locale: 'zh-CN' | 'zh-TW'): string {
  if (chineseVoiceKind(voice) === 'chinese') return voice.name
  let name = voice.name.split(' - ')[0]!.replace(/\bOnline\b(?:\s*\(Natural\))?|\(Natural\)/gi, '').trim()
  const microsoft = /^Microsoft\s+/i.test(name)
  name = name.replace(/^Microsoft\s+/i, '').replace(/\b(Xiaoxiao|Yunxi|Huihui|Yaoyao|Kangkang|Hanhan)\b/gi, value => names[value.toLowerCase()]![locale === 'zh-TW' ? 1 : 0])
  name = name.replace(/^(Google)\s+(?:Chinese|Mandarin|Cantonese|普通话|普通話|国语|國語|粤语|粵語|中文).*$/i, '$1')
  if (microsoft) name = (locale === 'zh-TW' ? '微軟' : '微软') + (/^[\u3400-\u9fff]/.test(name) ? '' : ' ') + name
  return name || voice.name
}

export function systemVoiceOptions(voices: SpeechSynthesisVoice[], locale: AppLocale) {
  const copy = buffSpeechCopy[locale]
  const options = voices.map(voice => {
    const source = voice.localService ? copy.local : copy.online
    const label = locale === 'zh-CN' || locale === 'zh-TW'
      ? `${languages[locale][chineseVoiceKind(voice)]} · ${chineseVoiceName(voice, locale)} · ${source}`
      : `${voice.name.split(' - ')[0]} · ${source}`
    return { id: voiceId(voice), name: voice.name, local: voice.localService, label }
  })
  const groups = new Map<string, typeof options>()
  for (const option of options) {
    const group = groups.get(option.label) ?? []
    group.push(option); groups.set(option.label, group)
  }
  return options.map(option => {
    const group = groups.get(option.label)!
    if (group.length === 1) return option
    const detail = group.some(other => other !== option && other.name === option.name) ? option.id : option.name
    return { ...option, label: `${option.label}（${detail}）` }
  })
}
